export default __webpack_public_path__ + "149dad93d4b9460f68bf8530da7e4a25.png";